import { HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Apollo } from 'apollo-angular';
import html2canvas from 'html2canvas';
import moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { DataService } from '../../../services/data/data.service';
import { ExcelService } from '../../../services/excel/excel.service';
import { environment } from '../../../../environments/environment';
import Swal from 'sweetalert2';
import { ConstantesImagenes } from '../../../models/Cuestionarios/codigoimagenes';
import { HojaRespuestasService } from '../../../services/cuestionarios/cuestionario/hoja-respuestas.service';
import ApexCharts from 'apexcharts';
import { toPng } from 'html-to-image';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { messages } from '../../funciones/mensajes';

// Registrar fuentes virtuales
pdfMake.addVirtualFileSystem(pdfFonts);
@Component({
  selector: 'app-reportes',
  templateUrl: './reportes.component.html',
  styleUrl: './reportes.component.css'
})
export class ReportesComponent {
  private headers = new HttpHeaders().append('Authorization', 'Bearer ' + localStorage.getItem('token'));  

  public allocationId = undefined;
  public allocationSelect = undefined;
  private questionaryId = undefined;
  public questionarySelect = undefined;
  public allocations = [];
  private answersSheet = [];
  public semaforos = [];
  public impAntecedentes: boolean = true;
  public impComponentes: boolean = true;
  public impElementos: boolean = false;

  private colorMulti: any = ['#2843A0','#15A075','#36CAE8','#78EAD2','#F88476','#E23E6A'];
  public options: any = {};
  public chart;
  public labelsG1 = false;
  public options2: any = {};
  public chart2;
  public chart3;
  public labelsG2 = false;
  public tipo = '';
  public isFunel = false;
  public encabezadoGraf1 = '';

  //variables reporte
  private imgComponentes = [];
  private imgGenaral;
  public txtIntro = this.translate.instant('cues.reporte.textoIntro');
  public guardarAnte = false;
  public txtAntece = '';

  public reporteGeneradoExitosamente: boolean = true;
  public isDownloadingPdf = false;
  private reportName = 'Reporte.pdf';
  private imgLogo;
  private pdfFile: any;
  public descargaDisponible = false;

  constructor(
    public dataService: DataService,
    private apollo: Apollo,
    private cookieService: CookieService,
    private translate: TranslateService,
    private imageService: HojaRespuestasService
    // private excel: ExcelService
  ){
    this.getLogo();
  }

  ngOnInit(){
    this.getInformation();
  }
  /* Consultas */
  private async getInformation(){
    this.answersSheet = JSON.parse(localStorage.getItem('answers'));
    this.allocationSelect = JSON.parse(localStorage.getItem('allocation'));
    const cuestionario = JSON.parse(localStorage.getItem('cuestionario'));

    var eleme = this.ListelementosCategories(cuestionario.categories, null);
    var peso = 0, numPreg = 0;
    for(const e of eleme){
      peso += e.ponderacion*e.peso/100;
      numPreg += e.numPreg;
    }

    this.semaforos = [];
    var aux = JSON.parse(JSON.stringify(cuestionario.semaphores));
    aux.sort( function(a,b){
      if ( Number(a.value_1) < Number(b.value_1) ) {
        return 1;
      }
      if ( Number(a.value_1) > Number(b.value_1) ) {
        return -1;
      }
      return 0;
    });
    var titN = 1;

    for(const sem of aux){
      var name = this.translate.instant('cues.resultados.titulo-semaforo-'+titN);
      if(name === ('cues.resultados.titulo-semaforo-'+titN)){
        name = '';
      }
      this.semaforos.push({
        name: name,
        min: sem.value_1,
        max: sem.value_2,
        color: sem.color
      });
      titN++;
    }

    peso = Number(peso.toFixed(1));

    this.questionarySelect = {
      id: cuestionario.id,
      name: cuestionario.name,
      elementos: eleme,
      ponderacion: peso,
      numPreg: numPreg,
    }

    await new Promise( r => setTimeout(r,200));
    await this.grafGeneralCuestionario('bar',false, true, 'graficaBarGeneral')
    for(var i= 0; i<this.questionarySelect.elementos.length; i++){
      await this.grafBarElementos(this.questionarySelect.elementos[i], i)
    }

    this.descargaDisponible = true;
    Swal.close();
    
  }
   /* obtención elementos */
  private ListelementosCategories(elements, id){
    var elementos = [];
    var cat;
    if(id === null){
      cat = elements.filter( e => e.parent === id);
    }else{
      cat = elements.filter( e => e.parent !== null && e.parent.id === id);
    }

    cat.sort(function(a,b){
      if ( Number(a.id) > Number(b.id) ) {
        return 1;
      }
      if ( Number(a.id) < Number(b.id) ) {
        return -1;
      }
      return 0;
    });

    for(const e of cat){
      const quest = this.structureQuestions(e.questions);
      const eleme = this.ListelementosCategories(elements, e.id);
      var peso = 0, numPreg = 0, numPregReales = 0, ponderacionMax = 0;
      if(quest.length !== 0){
        for(const q of quest){
          if(q.aplica){
            peso += q.ponderacion*q.peso/100;
            ponderacionMax += q.peso;
            numPregReales++;
          }
          numPreg++;
        }
        peso = peso*100/ponderacionMax;
      }else if(eleme.length !== 0){
        for(const e of eleme){
          peso += e.ponderacion*e.peso/100;
          numPreg += e.numPreg;
        }
      }
      peso = Number(peso.toFixed(1));

      elementos.push({
        id: e.id,
        name: e.name,
        description: e.description,
        parent: e.parent,
        numPreg: numPreg,
        elementos: eleme,
        questions: quest,
        ponderacion: peso,
        peso: e.weighting
      });
    }
    return elementos;
  }
  private structureQuestions(questions){
    var newQuestions = [];

    for(const q of questions){
      var res = [];
      for(const r of q.answers_options){
        res.push({
          id: r.id,
          respuesta: r.description,
          score: r.score,
        });
      }
      const answer = this.answersSheet.find(c => c.idQuestion === q.id);
      var valor = 0;
      var aplica = true;

      try{
        const respuesta = res.find(c => c.id === answer.idAnswer).respuesta;
        if(respuesta.toLowerCase() === 'no aplica' || respuesta.toLowerCase() === 'no le aplica'){
          aplica = false;
        }
        valor = res.find(c => c.id === answer.idAnswer).score*10/10;
      }catch(err){
      }

      valor = Number(valor.toFixed(1));

      newQuestions.push({
        id: q.id,
        descripcion: q.description,
        order: q.order,
        requerida: q.required,
        respuestas: res,
        ponderacion: valor,
        peso: q.weighting,
        aplica
      });
    }

    return newQuestions;
  }
  // grafica de la esquina inferior derecha tablero resultados
  public grafComponenteElemento(){
    var data = [];
    var titles = [];
    var max = 0;
    for(const com of this.questionarySelect.elementos){
      if(com.elementos.length > max ){
        max = com.elementos.length;
      }
    }

    for(var i = 0; i<max; i++){
      data.push({
        name: "",
        data: [],
        extra: this.questionarySelect
      });
    }

    for(const com of this.questionarySelect.elementos){    
      if(com.name.length > 20){
        var aux = [];
        for(var i = 0; i <= com.name.length/20; i++){
          if((i+1)*20 > com.name.length){
            aux.push(com.name.slice(i*20));
          }else{
            aux.push(com.name.slice(i*20,(i+1)*20));
          }
        }
        titles.push(aux);
      }else{
        titles.push(com.name);
      }

      var i = 0;
      for(const el of com.elementos){
        data[i].data.push(el.ponderacion);
        i++;
      }
      if(i<max){
        for(var j = i; j<max; j++){
          data[j].data.push(0);
        }
      }
    }

    this.options = {
      series: data,
      xaxis: {
        categories: titles,
        labels: {
          maxHeight: 600,
          rotate: 0,
          trim: false
        },
        tooltip:{
          enabled: false,
          theme: "dark"
        },
      },
      yaxis: {
        labels: {
          show: true,
          style: {
            fontSize: '16px',
            fontWeight: 400,
          },
        },
      },
      chart: {
        type: "bar",
        width: "100%",
        height: "100%",
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        },
        animations: {
          enabled: false
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "90%",
          borderRadius: 5,
          borderRadiuesApplication: 'end',
          dataLabels: {
            position: "top",
          },
        }
      },
      colors: this.colorMulti,
      fill: {
        opacity: 0.8
      },
      grid: {
        show: false
      },
      dataLabels: {
        enabled: this.labelsG1,
        position: "top",
        offsetY: -20,
        style: {
          fontSize: "12px",
          colors: ["#304758"]
        },
        formatter: function (val, opt) {
          return val!==0 ? val: '';
        },
      },
      markers: {
        size: 6,
        hover: {
          size: 6
        },
        fillOpacity: 1
      },
      stroke:{
        show: true,
        curve: "smooth"
      },
      
      tooltip: {
        y: {
          formatter: function(val, {seriesIndex}) {
            return val;
          }
        },
        x: {
          formatter: function(val, {seriesIndex, w }) {
            let imp = '';
            if(Array.isArray(val)){
              let valAux = '';
              for(const d of val){
                valAux += d;
              }
              val = valAux;
            }
            const com = w.config.series[0].extra.elementos.find(c => c.name === val);
            return 'Componente: '+val+'<br>Elemento: '+com.elementos[seriesIndex].name;
          }
        },
      },
      legend: {
        show: false
      }
    };

    setTimeout(() =>{  
      var chart = new ApexCharts(
        document.querySelector("#graficaBarComponentes"),//id del div 
        this.options
      );
      chart.render();
      this.options.stroke["show"] = true;
    }, 100);
  }

  //grafica de esquina superior derecha tablero de resultados
  public grafGeneralCuestionario(tipo: string, isFunel: boolean, labels: boolean,contenedor: string){
    this.labelsG2 = labels;
    this.tipo = tipo;
    this.isFunel = isFunel;
    var color = [];
    var data = [], dat = [], etiquetas = [];
    for(const el of this.questionarySelect.elementos){
      dat.push(el.ponderacion);
      if(el.name.length > 20){
        var aux = [];
        for(var i = 0; i <= el.name.length/20; i++){
          if((i+1)*20 > el.name.length){
            aux.push(el.name.slice(i*20));
          }else{
            aux.push(el.name.slice(i*20,(i+1)*20));
          }
        }
        etiquetas.push(aux);
      }else{
        etiquetas.push(el.name);
      }
      var col = this.semaforos.find(s => s.min <= el.ponderacion && el.ponderacion <= s.max).color;
      color.push(col);
    }

    dat.sort(function(a,b){
      if ( Number(a) > Number(b) ) {
        return 1;
      }
      if ( Number(a) < Number(b) ) {
        return -1;
      }
      return 0;
    });
    
    if(tipo == 'bar'){
      data.push({
        name: "",
        data: dat,
        extra: etiquetas
      });
    }else{
      for(const d of dat){
        data.push(d*10)
      }
    }
    let lab;
    var legends = false;

    if(tipo === 'radialBar'){
      legends = true;
    }

    var options2 = {
      series: data,
      xaxis: {
        categories: etiquetas,
        labels: {
          maxHeight: 600,
          rotate: 0,
          trim: false,
          style: {
              fontSize: '22px',
          },
        },
        tooltip:{
          enabled: false,
          theme: "dark"
        },
      },
      yaxis: {
        labels: {
          show: true,
          style: {
            fontSize: '16px',
            fontWeight: 400,
          },
        },
      },
      tooltip: {
        x:{
          formatter: function(val, {seriesIndex, w }) {
            if(Array.isArray(val)){
              let valAux = '';
              for(const d of val){
                valAux += d;
              }
              val = valAux;
            }
            return val;
          }
        }
      },
      chart: {
        type: tipo,
        width: "100%",
        height: "100%",
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        },
        animations: {
          enabled: false
        }
      },
      plotOptions: {
        bar: {
          columnWidth: "45%",
          borderRadius: 5,
          borderRadiuesApplication: 'end',
          horizontal: isFunel,
          distributed: true,
          barHeight: "80%",
          isFunnel: isFunel,
          dataLabels: {
            position: "top",
          },  
        },
        radialBar: {
          // startAngle: -90,
          // endAngle: 90,
          offsetY: 0,
          startAngle: 0,
          endAngle: 270,
          hollow: {
            margin: 5,
            size: "30%",
            background: "transparent",
            image: undefined
          },
          dataLabels: {
            name: {
              show: false,
              fontSize: "16px",
              fontWeight: 800,
              color: 'black',
              // offsetY: -130
            },
            value: {
              show: false,
              fontSize: "25px",
              fontWeight: 800,
              // offsetY: -12,
              formatter: function(val) {
                return Number(val)/10;
              }
            },

            total: {
              show: false,
              label: "Componentes",
              formatter: function(w) {
                return "";
              }
            }
          }
        }
      },
      labels: etiquetas,
      colors: color,
      fill: {
        opacity: 0.8
      },
      grid: {
        show: false
      },
      markers: {
        size: 6,
        hover: {
          size: 6
        },
        fillOpacity: 1
      },
      dataLabels: {
        enabled: this.labelsG2,
        position: "top",
        offsetY: -20,
        style: {
          fontSize: "16px",
          colors: ["#304758"]
        },
        formatter: function (val, opt) {
          return val!==0 ? val: '';
        },
      },
      stroke:{
        show: true,
        curve: "smooth"
      },
      legend: {
        show: legends,
        floating: true,
        fontSize: "12px",
        position: "left",
        width: 500,
        offsetX: 50,
        offsetY: 10,
        labels: {
          useSeriesColors: false
        },
        formatter: function(seriesName, opts) {
          if(Array.isArray(seriesName)){
            let valAux = '';
            for(const d of seriesName){
              valAux += d;
            }
            seriesName = valAux;
          }
          return seriesName + ":  " + (opts.w.globals.series[opts.seriesIndex]/10).toFixed(1);
        },
        itemMargin: {
          horizontal: 3
        }
      },
    }
    setTimeout(() =>{  
      if(tipo == 'bar'){
        this.chart2 = new ApexCharts(
          document.querySelector("#graficaBarGeneral"),//id del div 
          options2
        );
        this.chart2.render();
      }
      if(tipo == 'radialBar'){
        this.chart3 = new ApexCharts(
          document.querySelector("#graficaRadialGeneral"),//id del div 
          options2
        );
        this.chart3.render();
      }
    }, 100);
  }

  // grafica de barras para mostrar los elementos de los componentes
  public grafBarElementos(elements, contenedor){
    this.encabezadoGraf1 = elements.name;
    var color = [];
    var data = [], dat = [], etiquetas = [];
    for(const el of elements.elementos){
      dat.push(el.ponderacion);
      if(el.name.length > 20){
        var aux = [];
        for(var i = 0; i <= el.name.length/20; i++){
          if((i+1)*20 > el.name.length){
            aux.push(el.name.slice(i*20));
          }else{
            aux.push(el.name.slice(i*20,(i+1)*20));
          }
        }
        etiquetas.push(aux);
      }else{
        etiquetas.push(el.name);
      }
      var col = this.semaforos.find(s => s.min <= el.ponderacion && el.ponderacion <= s.max).color;
      color.push(col);
    }
    data.push({
      name: elements.name,
      data: dat,
    });
    
    var options = {
      series: data,
      xaxis: {
        categories: etiquetas,
        labels: {
          maxHeight: 600,
          rotate: 0,
          trim: false,
          style: {
              fontSize: '22px',
          },
        },
        tooltip:{
          enabled: false,
          theme: "dark"
        },
      },
      yaxis: {
        labels: {
          show: true,
          style: {
            fontSize: '16px',
            fontWeight: 400,
          },
        },
      },
      tooltip: {
        x:{
          formatter: function(val, {seriesIndex, w }) {
            if(Array.isArray(val)){
              let valAux = '';
              for(const d of val){
                valAux += d;
              }
              val = valAux;
            }
            return val;
          }
        }
      },
      chart: {
        type: "bar",
        width: "100%",
        height: "100%",
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        },
        animations: {
          enabled: false
        }
      },
      plotOptions: {
        bar: {
          columnWidth: "45%",
          distributed: true,
          borderRadius: 5,
          borderRadiuesApplication: 'end',
          dataLabels: {
            position: "top",
          },
        }
      },
      colors: color,
      fill: {
        opacity: 0.8
      },
      dataLabels: {
        enabled: true,
        position: "top",
        offsetY: -20,
        style: {
          fontSize: "16px",
          colors: ["#304758"]
        },
        formatter: function (val, opt) {
          return val!==0 ? val: '';
        },
      },
      grid: {
        show: false
      },
      markers: {
        size: 6,
        hover: {
          size: 6
        },
        fillOpacity: 1
      },
      stroke:{
        show: true,
        curve: "smooth"
      },
      legend: {
        show: false
      }
    };

    setTimeout(() =>{  
      options.stroke["show"] = true;
      var chart = new ApexCharts(
        document.querySelector("#graficaCmp"+contenedor),//id del div 
        options
      );
      chart.render();
    }, 100);
  }

  public async validaDescarga(){
    if(this.guardarAnte){
      const result = await messages.confirmationSave(
        this.translate.instant('cues.reporte.tituloNoGuardado'),
        this.translate.instant('acciones.continuar'),
        this.translate
      );
      if(result){
        this.descargarReporte();
      }
    }else{
      this.descargarReporte();
    }
    
  }

  public async descargarReporte(){
    try{
      messages.messageSaving(this.translate.instant('acciones.descarga'),this.translate.instant('acciones.espera'))

      this.isDownloadingPdf = true;
      this.reporteGeneradoExitosamente = false;

      await new Promise( r => setTimeout(r,50));
      if(this.impComponentes){
        await this.generarImagen('grafBarGeneral',0.5);
      }
      if(this.impElementos){
        for(var i= 0; i<this.questionarySelect.elementos.length; i++){
          await this.generarImagen('grafCmp'+i,0.8);
        }
      }

      const fechaPiePag = new Date().toLocaleDateString('es-MX', {month: '2-digit',day: '2-digit',year: '2-digit',});
      const horaPiePag = new Date().toLocaleTimeString('es-MX');
      const currentUser = this.dataService.user;
      const docPDF = {
        pageSize: 'FOLIO',
        images: {
          logoAleema: ConstantesImagenes.fondoblanco,
        },
        footer: function (currentPage, pageCount){
          if(currentPage == 1){
            return null;
          }
          if(currentPage === pageCount){
            return{
              columns: [
                {
                  image: 'logoAleema',
                  width: 70,
                  margin: [30, -1, 30, 0],
                },
                {
                  text: `${currentUser}  |  ${fechaPiePag}  |  ${horaPiePag}`,
                  alignment: 'center',
                  width: '*',
                  color: '#808080',
                  fontSize: 10,
                },

                {
                  text: (currentPage - 1).toString(),
                  color: '#808080',
                  fontSize: 10,
                  width: 'auto',
                  margin: [10, -1, 30, 0],
                },
              ]
            }
          }else{
            return{
              text: {
                  text: (currentPage - 1).toString(),
                  alignment: 'right',
                  color: '#808080',
                  fontSize: 10,
                  width: 'auto',
                },margin: [10, -1, 30, 0],
            }
          }
        },
        content: [
          // Portada
          this.portada(),
          // Antecedentes
          this.impAntecedentes ? this.antecedentes() : {text: ''},
          // Componentes
          this.impComponentes ? this.componentes() : {text: ''},
          // detalle componente-elemento
          this.impElementos ? this.detalleComponente() : {text: ''},
        ]
      }
      this.reporteGeneradoExitosamente = true;
    
      this.reportName = 'Reporte general '+this.questionarySelect.name+'.pdf';
      
      const pdf = pdfMake.createPdf(docPDF);
      await pdf.download(this.reportName);
      const blob = await pdf.getBlob();

      this.pdfFile = blob;
      Swal.close();
      messages.succesMessageGraph(this.translate.instant('acciones.desExito'))
      setTimeout(() => {
        this.isDownloadingPdf = false;
      }, 2000);
    }catch(error){
      this.reporteGeneradoExitosamente = false;
      Swal.close();
      Swal.fire({title: this.translate.instant('cues.reporte.errorReporte'), timer: 10000});
    }
  }
  private async getLogo(){
    try {
      
      const response = await firstValueFrom(this.imageService.getLogo(this.dataService.idInstitution));
      for(const doc of response){
        const name = (''+doc['filename']).split('.');
        const nomsep = name[0].split('_');
        for(const nam of nomsep){
          if( nam.toLocaleLowerCase() === 'logo' ){
            const imageResponse = await firstValueFrom(this.imageService.getArchivosA(doc._id));
              var base = 'data:image/'+name[name.length-1]+';base64,'+btoa(new Uint8Array(imageResponse).reduce((data, byte) => data + String.fromCharCode(byte), ''));
              this.imgLogo = base;
            break;
          }
        }
      } 
    } catch (error) {
      
    }
  }

  private portada(){
    var portada = [];
    portada = [
      this.imgLogo !== '' && this.imgLogo !== undefined ? {
        image: this.imgLogo,
        width: 220,
        margin: [0, 0, 10, 0],
        absolutePosition: { y: 60 },
        alignment: 'right',
      } : { text: '' },
      {
        text: this.translate.instant('cues.reporte.resultados'),
        style: 'header',
        bold: true,
        fontSize: 30,
        color: 'black',
        margin: [60, 250, 0, 0],
      },
      {
        text: this.questionarySelect.name,
        style: 'header',
        bold: true,
        fontSize: 30,
        color: 'black',
        margin: [60, 5, 0, 0],
      },
      // {
      //   text: 'Calificación: ' + this.questionarySelect['ponderacion'],
      //   style: 'header',
      //   bold: true,
      //   fontSize: 20,
      //   color: 'black',
      //   margin: [60, 25, 0, 0],
      // },
      {
        text: moment(this.allocationSelect.start_date).format("MMM YYYY"),
        style: 'header',
        bold: true,
        fontSize: 18,
        color: 'black',
        margin: [60, 45, 0, 0],
      },
      // [
      //   {text: '', pageBreak: 'after'}
      // ],          
    ]
    return portada;
  }

  private antecedentes(){
    var intro = [];
    intro = [
      {text: '', pageBreak: 'after'},
      {
        table: {
          headerRows: 0,
          widths: ['*'],
          body: [
            [
              {
                text: this.translate.instant('cues.reporte.antecedentes'),
                style: 'header',
                fontSize: 20,
                color: 'black',
                bold: true,
                margin: [ 5, 5, 5, 5 ],
                fillColor: '#ffff00'
              },
            ]
          ],

        },
        margin: [ 0, 0, 0, 15 ],
        border: [false, false, false, false],
        layout: {
          hLineColor: function (i) {
            return 'white';
          }
          , vLineColor: function (i, node) {  
            return 'white';
          } 
        }
      },    
      {
        text: this.txtAntece+'\n\n',
        style: 'header',
        fontSize: 12,
        color: 'black',
        bold: false,
        alignment: 'justify',
        lineHeight: 1.2,
        margin: [ 20, 0, 0, 0 ],
      },  
      
      
    ]
    return intro;
  }

  private componentes(){
    var cmp = [];
    var aux = [];
    for(const c of this.questionarySelect['elementos']){
      aux.push(c.name)
    }
    var tablaCmp = [
      [{
          text: this.translate.instant('cues.reporte.textMarco') +this.questionarySelect.elementos.length + this.translate.instant('cues.reporte.compo'),
          style:'header',
          color: 'black',
          fontSize: 12,
          bold: true,
          margin: [ 20, 30, 0, 10 ],
      }],
      [{
        ul:aux,
        style:'header',
        color: 'black',
        bold: false,
        fontSize:12,
        alignment: 'justify',
        margin: [ 30, 10, 0, 0 ],
      }]
    ]

    cmp = [
      {text: '', pageBreak: 'after'},
      {
        table: {
          headerRows: 0,
          widths: ['*'],
          body: [
            [
              {
                text: this.translate.instant('cues.reporte.textComp') + this.questionarySelect.name,
                style: 'header',
                fontSize: 20,
                color: 'black',
                bold: true,
                margin: [ 5, 5, 5, 5 ],
                fillColor: '#ffff00'
              },
            ]
          ],

        },
        margin: [ 0, 0, 0, 15 ],
        border: [false, false, false, false],
        layout: {
          hLineColor: function (i) {
            return 'white';
          }
          , vLineColor: function (i, node) {  
            return 'white';
          } 
        }
      },
      
      {
        text: this.dataService.company_name+'\n\n',
        style: 'header',
        fontSize: 15,
        color: 'black',
        bold: false,
        margin: [ 20, 0, 0, 0 ],
      },
      {
        text: this.txtIntro+'\n\n',
        style: 'header',
        fontSize: 12,
        color: 'black',
        bold: false,
        alignment: 'justify',
        lineHeight: 1.2,
        margin: [ 20, 0, 0, 0 ],
      },
      {
        text: this.translate.instant('cues.reporte.textControl'),
        style: 'header',
        fontSize: 12,
        color: 'black',
        bold: false,
        margin: [ 20, 0, 0, 0 ],
      },
      {
        text: this.translate.instant('cues.reporte.textComp1') + this.questionarySelect.elementos.length + this.translate.instant('cues.reporte.textComp2'),
        style: 'header',
        fontSize: 12,
        color: 'black',
        bold: false,
        margin: [ 35, 0, 0, 0 ],
      },
      {
        table: {
          headerRows: 1,
          widths:['*'],
          body:tablaCmp,
        },
        layout:{
          hLineColor: function(i,node){
            if(i === 1){
              return '#ffff00'
            }              
            return 'white'
          },
          vLineColor: function (i, node) {
            return 'white';
          },
        }
      },
      {
        text: this.translate.instant('cues.reporte.textResult'),
        style: 'header',
        fontSize: 12,
        color: 'black',
        bold: true,
        margin: [ 20, 20, 0, 10 ],
      },
      {
        table: {
          headerRows: 0,
          widths: [300,200],
          // body: tabla,
          body: [
            [
              {
                table:{
                  headerRows:1,
                  widths: [300],
                  body: [
                    [
                      {
                        text: [{ text:this.questionarySelect['ponderacion'], fontSize: 25, bold: true, color:'#1b48ab'},{text:'     Calificación global', fontSize: 12, bold: false, color:'#1b48ab'}],
                        style: 'header',
                        bold: true,
                        fontSize: 25,
                        color: 'black',
                        alignment: 'center',
                        // margin: [20, 0, 0, 0], 
                        fillColor: '#d6deef'
                      }
                    ],
                    [
                      this.imgGenaral !== undefined ? {
                        image: this.imgGenaral,
                        width: 320,
                        alignment: 'center',
                      } : { text: '' },
                    ]

                  ]
                },
                border: [false, false, false, false],
                layout: {
                  hLineColor: function (i) {
                    return 'white';
                  },
                  vLineColor: function (i, node) {
                    return 'white';
                  },
                },
              },
              {
                table:{
                  headerRows:1,
                  widths: [200],
                  body: [
                    [
                      {
                        text: this.translate.instant('cues.asignacion.tituloMide') +'\n',
                        style: 'header',
                        bold: false,
                        fontSize: 14,
                        color: '#1b48ab',
                        margin: [20, 10, 0, 10], 
                        fillColor: '#f4f4f4'
                      },
                      
                    ],
                    [
                      {
                        ul:[
                          this.translate.instant('cues.asignacion.mide1'),
                          this.translate.instant('cues.asignacion.mide2'),
                          this.translate.instant('cues.asignacion.mide3')
                        ],
                        style: 'header',
                        fontSize: 14,
                        color: '#1b48ab',
                        bold: false,
                        alignment: 'left',
                        fillColor: '#f4f4f4',
                        margin: [ 30, 0, 0, 0 ],
                      }
                    ]
                  ]
                },
                border: [false, false, false, true],
                layout: {
                  hLineColor: function (i) {
                    return '#f4f4f4';
                  },
                  vLineColor: function (i, node) {
                    return 'white';
                  },
                },
              }
            ]
          ],
        },
        border: [false, false, false, false],
        layout: {
          hLineColor: function (i) {
            return 'white';
          },
          vLineColor: function (i, node) {
            return 'white';
          },
        },
      },
      // this.imgReporte[1] !== undefined ? {
      //   image: this.imgReporte[1],
      //   width: 650,
      //   alignment: 'center',
      //   margin:[300,0,0,0]
      // } : { text: '' },      
    ]

    return cmp;
  }

  private detalleComponente(){
    var auxtd = [];
    for(var i = 0; i<this.questionarySelect.elementos.length; i++){
      auxtd.push(
        {
          table: {
            headerRows: 0,
            widths: ['*'],
            body: [
              [
                {
                  text: this.questionarySelect.elementos[i].name,
                  style: 'header',
                  fontSize: 16,
                  color: 'black',
                  bold: true,
                  margin: [ 0, 0, 0, 0 ],
                },
              ]
            ],
  
          },
          margin: [ 0, 0, 0, 15 ],
          border: [false, false, false, true],
          layout: {
            hLineColor: function (i) {
              if(i === 1){
                return '#ffff00'
              }  
              return 'white';
            }
            , vLineColor: function (i, node) {  
              return 'white';
            } 
          }
        },
        {
          text: this.questionarySelect.elementos[i].description,
          style: 'header',
          fontSize: 12,
          color: 'black',
          bold: false,
          alignment: 'justify',
          margin: [ 20, 0, 0, 10 ],
        },
        {
          image: this.imgComponentes[i],
          width: 450,
          alignment: 'center',
        },
      )
    }
    
    var dt = [];

    dt = [
      {text: '', pageBreak: 'after'},
      {
        table: {
          headerRows: 0,
          widths: ['*'],
          body: [
            [
              {
                text: this.translate.instant('cues.reporte.textEvaluacion'),
                style: 'header',
                fontSize: 20,
                color: 'black',
                bold: true,
                margin: [ 0, 0, 0, 0 ],
                fillColor: '#ffff00'
              },
            ]
          ],

        },
        margin: [ 0, 0, 0, 15 ],
        border: [false, false, false, false],
        layout: {
          hLineColor: function (i) {
            return 'white';
          }
          , vLineColor: function (i, node) {  
            return 'white';
          } 
        }
      },
      auxtd,
    ]

    return dt;
  }

/// Generar imagenes para el reporte recibiendo el id del contenedor
  private async generarImagen(contenedor:string, scale: number){
    const canvas = await toPng(document.getElementById(contenedor),{
      skipFonts: true,
      skipAutoScale: true,
      filter: (node) => {
        // Opcional: excluir elementos problemáticos
        return !node.classList?.contains('dropdown-toggle');
      }
    })
    // const canvas = await html2canvas(
    //   document.querySelector('#'+contenedor),
    //   {
    //     scale: scale,
    //     backgroundColor: 'white',
    //     logging: false,
    //     useCORS: true,
    //     ignoreElements: (el) => el.classList.contains('no-capture'),
    //     windowWidth: document.querySelector('#'+contenedor).scrollWidth,
    //     windowHeight: document.querySelector('#'+contenedor).scrollHeight
    //   }
    // );
    if(contenedor === 'grafBarGeneral'){
      this.imgGenaral= canvas;
    }else{
      this.imgComponentes.push(canvas)
    }
  }

  public guardarIntro(){
    const introElement = document.getElementById('intro') as HTMLInputElement;
    const value = introElement.value;
    this.txtAntece = value;
    messages.succesMessageGraph(this.translate.instant('acciones.guardado'));
    this.guardarAnte = false;    
  }

  public onTextAreaChange(event: Event): void {
    // const inputValue = (event.target as HTMLTextAreaElement).value;
    this.guardarAnte = true;
  }
  /**
   * Función que se encarga de revisar cuando s quiere activar los elementos si existen
   */
  existenElementos(event){
    if (!this.impElementos) {
      return;
    }
    const ex = this.questionarySelect.elementos.find(ele => ele.elementos?.length);
    if(!ex){
      messages.infoMessageGraph('No existen elemenos en este cuestionarios');
      event.source.checked = false;
      this.impElementos = false;
    }
  }
}
